{
  "version": 1,
  "asset_id": "a58e3ada-6af4-4741-a376-0828b205ac4b",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/a58e3ada-6af4-4741-a376-0828b205ac4b/entrevista-carnaval-tv-tem.jpg",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/a58e3ada-6af4-4741-a376-0828b205ac4b/entrevista-carnaval-tv-tem.jpg",
  "original_filename": "entrevista-carnaval-tv-tem.jpg",
  "size": 82737,
  "content_type": "image/jpeg",
  "created_at": "2026-09-21T21:35:32Z"
}
